module.exports = __webpack_public_path__ + "img/thumbnail_JapaneseMacaque_f_normal.80cad4ec.png";